var MonthLogTable = require('components/reading/logs/MonthLogTable.js');
require('reading/logs/log_table.scss');

class AllMonthsLogTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { expanded: false };
	}

	expandFromSoftMax() {
		this.setState({ expanded: true });
	}

	getFirstDay(date) {
		var parts = date.split("-");
		return parts[0] + "-" + parts[1] + "-01";
		//returns year-month-01
	}

	render() {
		var logs = this.props.logs;

		if (this.props.softMax && (this.props.softMax < logs.length) && !this.state.expanded) {
			logs = _.first(logs, this.props.softMax)
			var appliedSoftMax = true;
		} else {
			var appliedSoftMax = false;
		}

		var monthsMap = _.map(logs, function(log) {
			var month = this.getFirstDay(log.log_date)
			//y-m-01
			return month
		}.bind(this));
		//this returns a list of all the logs but months repeat, example: 2017-05-01, 2017-05-01

		var uniqueMonths = _.uniq(monthsMap);
		//here we eliminate duplicates, example only one 2017-05-01, 2017-04-01...etc

		var tableMonths = _.map(uniqueMonths, function(month) {
			//then we map through those

			var filteredLogs = _.filter(this.props.logs, function(log){
				var firstLogDay = this.getFirstDay(log.log_date)
				//_.filter returns boolean..so it will either give me a true or false
				return firstLogDay == month;
				//here I'm asking it to return when it's true that firstLogDay actually equals month

			}.bind(this));

			return (
				<MonthLogTable key={ month } month={ month }
					logs={ filteredLogs } initExpanded={ this.props.initExpanded } hideCommentBox={ this.props.hideCommentBox } 
					showFullData={ this.props.showFullData }
					condensedLayout={ this.props.condensedLayout } />
			);

		}.bind(this));

		if (appliedSoftMax) {
			var truncatedMessage = (
				<div className="truncatedPlaceholder">
					<button className="btn btn-link" onClick={ this.expandFromSoftMax }>
						Show { this.props.logs.length - logs.length } More
					</button>
				</div>
			);
		}

		var className = "allMonthsLogTable";
		if (this.props.embedded) {
			className += " embedded";
		} else {
			className += " standalone";
		}

		return(
			<div className={ className }>
				{ tableMonths }
				{ truncatedMessage }
			</div>
		)
	}
};

AllMonthsLogTable.propTypes = StrictPropTypes({
	logs: PropTypes.array.isRequired,
	embedded: PropTypes.bool,
	initExpanded: PropTypes.bool,
	hideCommentBox: PropTypes.bool,
	condensedLayout: PropTypes.bool,
	showFullData: PropTypes.bool,
	softMax: PropTypes.number,
});

module.exports = AllMonthsLogTable;



// WEBPACK FOOTER //
// ./modules/components/reading/logs/AllMonthsLogTable.js